import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import BMenu from '@/components/general/BMenu.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BSelect',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    block: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Number, String, Boolean],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    infoText: {
      type: String,
      default: ''
    },
    small: {
      type: Boolean,
      default: false
    },
    immediateEmit: {
      type: Boolean,
      default: true
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    matchContentWidth: {
      type: Boolean,
      default: false
    },
    dynamicOptions: {
      type: Boolean,
      default: false
    },
    bottomBorder: {
      type: Boolean,
      default: true
    }
  },
  emits: ['input', 'update:modelValue'],
  setup: function setup(__props, _ref) {
    var expose = _ref.expose,
      emit = _ref.emit;
    var props = __props;
    var select = ref();
    var menu = ref();
    var dropdown = ref(false);
    var items = ref([]);
    var selected = ref({
      id: null,
      content: ''
    });
    var width = ref(0);
    function onWindowChange() {
      // get position of select element
      var _select$value$getBoun = select.value.getBoundingClientRect(),
        top = _select$value$getBoun.top,
        left = _select$value$getBoun.left,
        height = _select$value$getBoun.height;
      // get height of the menu
      var menuHeight = menu.value.$el.offsetHeight;
      // calculate available space below the dropdown
      var spaceBelow = window.innerHeight - top - height;
      // set position of dropdown menu
      if (spaceBelow >= menuHeight) {
        // position menu below dropdown
        menu.value.$el.style.transform = "translate(".concat(left, "px, ").concat(top + height + 8, "px)");
      } else {
        // position menu above dropdown
        menu.value.$el.style.transform = "translate(".concat(left, "px, ").concat(top - menuHeight, "px)");
      }
    }
    function dropDown() {
      dropdown.value = !dropdown.value;
      width.value = select.value.offsetWidth;
    }
    function selectOption(option) {
      emit('input', option);
      emit('update:modelValue', option);
      selected.value = items.value.find(function (item) {
        return item.id === option;
      });
      dropdown.value = false;
    }
    function onClose() {
      dropdown.value = false;
    }
    watch(function () {
      return props.value;
    }, function (val) {
      var _selected$value;
      if (!props.immediateEmit) {
        return;
      }
      emit('input', (_selected$value = selected.value) === null || _selected$value === void 0 ? void 0 : _selected$value.id);
      selected.value = items.value.find(function (item) {
        return item.id === val;
      });
    }, {
      immediate: true
    });
    watch(function () {
      return props.options;
    }, function (val) {
      if (!props.dynamicOptions) {
        return;
      }
      items.value = val.map(function (option) {
        return {
          id: option.id,
          content: option.displayName
        };
      });
      items.value = items.value.filter(function (item, index, self) {
        return index === self.findIndex(function (t) {
          return t.id === item.id;
        });
      });
      selected.value = items.value.find(function (item) {
        return item.id === props.value;
      });
    }, {
      immediate: true
    });
    onMounted(function () {
      if (props.options.length > 0) {
        var _selected$value2;
        items.value = props.options.map(function (option) {
          return {
            id: option.id,
            content: option.displayName
          };
        });
        items.value = items.value.filter(function (item, index, self) {
          return index === self.findIndex(function (t) {
            return t.id === item.id;
          });
        });
        selected.value = items.value.find(function (item) {
          return item.id === props.value;
        });
        emit('input', (_selected$value2 = selected.value) === null || _selected$value2 === void 0 ? void 0 : _selected$value2.id);
        emit('update:modelValue', selected.value);
        // add listener for scroll to position dropdown menu
        if (document.querySelector('.content') !== null) {
          document.querySelector('.content').addEventListener('scroll', onWindowChange);
        }
        onWindowChange();
      }
      // add listener for window resize and scroll to position dropdown menu
      window.addEventListener('resize', onWindowChange);
      window.addEventListener('scroll', onWindowChange);
    });
    onUnmounted(function () {
      window.removeEventListener('resize', onWindowChange);
      if (document.querySelector('.content') !== null) {
        document.querySelector('.content').removeEventListener('scroll', onWindowChange);
      }
      window.removeEventListener('scroll', onWindowChange);
    });
    expose({
      onClose: onClose
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      select: select,
      menu: menu,
      dropdown: dropdown,
      items: items,
      selected: selected,
      width: width,
      onWindowChange: onWindowChange,
      dropDown: dropDown,
      selectOption: selectOption,
      onClose: onClose,
      BMenu: BMenu
    };
  }
});